import React from 'react'
import './page404.css'

function PageNotFound() {
  return (
    <div id="main">
    	<div className="fof">
        		<h1>Error 404</h1>
    	</div>
    </div>
  )
}

export default PageNotFound